/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for updating a competitor.
 * @export
 * @interface CompetitorUpdate
 */
export interface CompetitorUpdate {
    /**
     * 
     * @type {string}
     * @memberof CompetitorUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompetitorUpdate
     */
    member_user_ids?: Array<string> | null;
}

/**
 * Check if a given object implements the CompetitorUpdate interface.
 */
export function instanceOfCompetitorUpdate(value: object): value is CompetitorUpdate {
    return true;
}

export function CompetitorUpdateFromJSON(json: any): CompetitorUpdate {
    return CompetitorUpdateFromJSONTyped(json, false);
}

export function CompetitorUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitorUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'member_user_ids': json['member_user_ids'] == null ? undefined : json['member_user_ids'],
    };
}

export function CompetitorUpdateToJSON(json: any): CompetitorUpdate {
    return CompetitorUpdateToJSONTyped(json, false);
}

export function CompetitorUpdateToJSONTyped(value?: CompetitorUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'member_user_ids': value['member_user_ids'],
    };
}

